import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AddressStaff } from "./AddressStaff";
import type { PersonStaff } from "./PersonStaff";
import type { PurchaseDeliveryDTOBase } from "./PurchaseDeliveryDTOBase";
import type { PurchaseDeliveryMethod } from "./PurchaseDeliveryMethod";
import type { PurchaseDeliveryStatus } from "./PurchaseDeliveryStatus";
import type { PurchaseDeliveryTarget } from "./PurchaseDeliveryTarget";

export class PurchaseDeliveryStaff implements PurchaseDeliveryDTOBase {
  constructor(public readonly assignId: number, public readonly target: PurchaseDeliveryTarget | null, public readonly method: PurchaseDeliveryMethod | null, public readonly deliveryStatus: PurchaseDeliveryStatus | null, public readonly deliveredOn: Date | null, public readonly targetPerson: PersonStaff | null, public readonly targetAddress: AddressStaff | null) {
    this.cbiServiceContext = null;
    this.targetPersonLoaded = this.targetPerson != null;
    this.targetPersonCached = this.targetPerson;
    this.targetAddressLoaded = this.targetAddress != null;
    this.targetAddressCached = this.targetAddress;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private targetPersonLoaded: boolean;
  private targetPersonCached: PersonStaff | null;
  private targetAddressLoaded: boolean;
  private targetAddressCached: AddressStaff | null;
  async targetPersonLazy(): Promise<PersonStaff | null> {
    if (!this.targetPersonLoaded) {
      this.targetPersonCached = await this.cbiServiceContext!.purchaseDeliveryService().getPurchaseDeliveryStaffTargetPerson(this.assignId);
      this.targetPersonLoaded = true;
    }
    return this.targetPersonCached;
  }
  async targetAddressLazy(): Promise<AddressStaff | null> {
    if (!this.targetAddressLoaded) {
      this.targetAddressCached = await this.cbiServiceContext!.purchaseDeliveryService().getPurchaseDeliveryStaffTargetAddress(this.assignId);
      this.targetAddressLoaded = true;
    }
    return this.targetAddressCached;
  }
}
